import React from "react"
import { useTranslation } from "react-i18next"

import { ButtonVariant } from "shared/ui/buttons/Button"
import { MarkdownPreview } from "shared/ui/input/markdown/components/MarkdownPreview"
import { FormOverlay } from "shared/ui/overlay/FormOverlay"

import "../styles/_profile-delete-overlay.scss"

export interface DataTableOverlayViewProps {
  onClose: () => void
  onSubmit: () => void
}

export const ProfileDeleteOverlayView = React.memo(
  ({ onClose, onSubmit }: DataTableOverlayViewProps) => {
    const { t } = useTranslation()

    return (
      <FormOverlay
        id="profile-delete-request-code-overlay"
        form="profile-delete-request-code-overlay"
        className="profile-delete-overlay"
        headline={t("UserProfile.DeleteProfile.AreYouSure")}
        submitButtonText={t("UserProfile.DeleteProfile.RequestCode")}
        cancelButtonText={t("General.Cancel")}
        submitButtonProps={{
          className: "profile-delete-actions__submit",
          onClick: onSubmit,
          isDanger: true
        }}
        cancelButtonProps={{
          variant: ButtonVariant.SECONDARY,
          className: "profile-delete-actions__cancel"
        }}
        showCloseButton
        onCancel={onClose}
        onSubmit={onSubmit}
      >
        <MarkdownPreview
          className="profile-delete-overlay__body"
          value={t("UserProfile.DeleteProfile.CodeRequestOverlay.WarningText")}
        />
      </FormOverlay>
    )
  }
)
